"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const BAA_VERSION = 'baa-2026-07'; exports.BAA_VERSION = BAA_VERSION
 const TOS_VERSION = 'tos-2026-10'; exports.TOS_VERSION = TOS_VERSION
